import Shepherd from 'shepherd.js';

if(($('.innovation-editor').length) || ($('.innovation-application-editor').length)){

    if(!$('.innovation-application-editor').length){
        if (!$('.onboarding-ai-assistant').length && $('.onboarding-innovation-editor').length) {
            ['close', 'cancel', 'complete'].forEach(event => Shepherd.on(event, () => {
                var data = {
                    'page': 'innovation-ai-assistant'
                };
                axios.post("/api/v1/onboarding", data)
                    .then((response) => {
                    }).catch(function (error) {
                    console.log('onboarding logged')
                });
            }));
        } else {
            ['close', 'cancel', 'complete'].forEach(event => Shepherd.on(event, () => {
                var data = {
                    'page': 'innovation-editor'
                };
                axios.post("/api/v1/onboarding", data)
                    .then((response) => {
                    }).catch(function (error) {
                    console.log('onboarding logged')
                });
                var data = {
                    'page': 'innovation-ai-assistant'
                };
                axios.post("/api/v1/onboarding", data)
                    .then((response) => {
                    }).catch(function (error) {
                    console.log('onboarding logged')
                });
            }));
        }
    }else{
        if (!$('.onboarding-ai-assistant').length && $('.onboarding-innovation-application-editor').length) {
            ['close', 'cancel', 'complete'].forEach(event => Shepherd.on(event, () => {
                var data = {
                    'page': 'innovation-ai-assistant'
                };
                axios.post("/api/v1/onboarding", data)
                    .then((response) => {
                    }).catch(function (error) {
                    console.log('onboarding logged')
                });
            }));
        } else {
            ['close', 'cancel', 'complete'].forEach(event => Shepherd.on(event, () => {
                var data = {
                    'page': 'innovation-application-editor'
                };
                axios.post("/api/v1/onboarding", data)
                    .then((response) => {
                    }).catch(function (error) {
                    console.log('onboarding logged')
                });
                var data = {
                    'page': 'innovation-editor'
                };
                axios.post("/api/v1/onboarding", data)
                    .then((response) => {
                    }).catch(function (error) {
                    console.log('onboarding logged')
                });
                var data = {
                    'page': 'innovation-ai-assistant'
                };
                axios.post("/api/v1/onboarding", data)
                    .then((response) => {
                    }).catch(function (error) {
                    console.log('onboarding logged')
                });
            }));
        }
    }

    const tour = new Shepherd.Tour({
        defaultStepOptions: {
            cancelIcon: {
                enabled: true
            },
            classes: 'shepherd-container',
            scrollTo: { behavior: 'smooth', block: 'center' }
        },
        useModalOverlay: true
    });

    const steps = [];
    
    if(!$('.innovation-application-editor').length){
        steps[0] = {
            title: 'The Innovation Editor',
            text: "Welcome to the Innovation Editor. This will show you how your innovation looks whilst you live edit it. You must complete all the fields in the 'Innovation Card Details' section to be able to publish your innovation.",
            buttons: [
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-1'
        };
    }else{
        steps[0] = {
            title: 'Start your application',
            text: "To start your application to this Challenge, you need to ensure your innovation or expertise profile is 100% complete on the Visual Editor. Radial progress bars will show you how close you are to completing the form and each individual section that contains required fields.",
            buttons: [
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-1'
        };
    }
    
    /*tour.addStep({
        title: 'Toggle between views',
        text: "Using these two toggles, you can switch the view mode between a full view of your innovation and the editor form. If you are creating an innovation for the first time, you will  see the 'Card View' first, but once you save, you will see the full innovation view.",
        attachTo: {
            element: '#editor-header .middle',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-2'
    });*/

    steps[1] = {
        title: 'Checking your progress',
        text: "This shows the percentage of your innovation progress completion. Once your innovation is 100% complete you will be able to apply to Challenges.",
        attachTo: {
            element: '.radial-progress',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-2'
    };

    steps[2] = {
        title: 'Filling in your Innovation Card Details',
        text: "Any section marked “REQUIRED” must be filled out to create an innovation on the platform. You can mark your innovation as private if you don't want it displayed publicly on the platform. Also, if you are part of a University on the platform, you can link it to that University.",
        attachTo: {
            element: '.editor-section#card-details',
            on: $(window).width() < 992 ? 'top' : 'right'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-3'
    };

    steps[3] = {
        title: 'Adding more detail',
        text: "Ensure you enter as many details as possible, to apply to Challenges and give your innovation the best chance to stand out on the platform.",
        attachTo: {
            element: '.editor-section#additional-details',
            on: 'top'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-4'
    };

    steps[4] = {
        title: 'Are you looking for funding?',
        text: "This section is optional. Let companies know if you are seeking funding or commerical opportunities.",
        attachTo: {
            element: '.editor-section#funding-details',
            on: 'top'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-5'
    };

    steps[5] = {
        title: 'Make it visual!',
        text: "Make your innovation stand out by adding your own image and banner. They must be in jpg format and under 2Mb. Don't worry if you don't add any images, as we'll select default ones for you based upon the primary sector you've chosen. You can also add a link to your Youtube or Vimeo video here.",
        attachTo: {
            element: '.editor-section#media-details',
            on: 'top'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-6'
    };


    if(!$('.innovation-application-editor').length){
        steps[6] = {
            title: 'Saving and Publishing',
            text: "You can use these buttons to 'Save' or 'Publish' your innovation. We encourage you to save your progress regularly. Your innovation will be kept in draft until you're finished and ready to publish it. Once published, you will also be able to archive it.",
            attachTo: {
                element: '#editor-header .right',
                on: 'bottom'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-7'
        };
    }else{
        steps[6] = {
            title: 'Continuing your application',
            text: "Once you're at 100% on your progress with this form, you can click 'Save and Continue'. If you are applying with an innovation, this will publish it as well if it is still in draft. If you are not finished yet, you can click 'Save'. After clicking 'Save and Continue' your application will be created in a draft state and you will be taken to the vetting page.",
            attachTo: {
                element: '#editor-header .right',
                on: 'bottom'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-7'
        };
    }

    if(!$('.innovation-application-editor').length){
        steps[7] = {
            title: "Once you're finished",
            text: "When you are finished in the editor, you can click this button to go back to your dashboard or the previous page. Make sure you've saved your innovation first though!",
            attachTo: {
                element: '#editor-header .left',
                on: 'bottom'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-8'
        };
    }else{
        steps[7] = {
            title: "Dont want to continue?",
            text: "If you dont want to continue your application or you want to come back to it later you can go back to the dashboard here.",
            attachTo: {
                element: '#editor-header .left',
                on: 'bottom'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-8'
        };
    }

    steps[8] = {
        title: "LEO have integrated an AI assistant",
        text: "Enter your Innovation title and URL to utilise the assistant.",
        attachTo: {
            element: '.shepherd-step-highlight',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-9'
    };

    steps[9] = {
        title: "LEO have integrated an AI assistant",
        text: "Click the wand to the right of any section heading for AI assistance.",
        attachTo: {
            element: '.ai-wand',
            on: 'right'
        },
        beforeShowPromise: function () {
            return new Promise(function (resolve) {
                (function checkIfElementExists() {
                    if (document.querySelector(".ai-active") !== null) {
                        resolve();
                    } else {
                        setTimeout(checkIfElementExists, 500);
                    }
                })();
            })
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.complete();
                },
                classes: 'btn btn--secondary',
                text: 'Finish'
            }
        ],
        id: 'step-10'
    };

    const ai_steps = [];

    ai_steps[0] = {
        title: "LEO have integrated an AI assistant",
        text: "Enter your Innovation title and URL to utilise the assistant.",
        attachTo: {
            element: '.shepherd-step-highlight',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'ai-step-1'
    };

    ai_steps[1] = {
        title: "LEO have integrated an AI assistant",
        text: "Click the wand to the right of any section heading for AI assistance.",
        attachTo: {
            element: '.ai-wand',
            on: 'right'
        },
        beforeShowPromise: function () {
            return new Promise(function (resolve) {
                (function checkIfElementExists() {
                    if (document.querySelector(".ai-active") !== null) {
                        resolve();
                    } else {
                        setTimeout(checkIfElementExists, 500);
                    }
                })();
            })
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.complete();
                },
                classes: 'btn btn--secondary',
                text: 'Finish'
            }
        ],
        id: 'ai-step-2'
    };

    $('.replay-onboarding').show();

    $('.replay-onboarding').click(function(){
        tour.addSteps(steps)
        tour.start();
    });

    if(($('.innovation-editor').length && !$('.onboarding-innovation-editor').length) || ($('.innovation-application-editor').length && !$('.onboarding-innovation-application-editor').length)){
        tour.addSteps(steps)
        tour.start();
    } else if (!$('.onboarding-ai-assistant').length) {
        tour.addSteps(ai_steps)
        setTimeout(runAISteps, 500);
    }

    function runAISteps() {
        tour.start();
    }
 }
